import PropTypes from 'prop-types';
import React, {Component} from "react";
import ReactDOM from "react-dom";
import autobind from "autobind-decorator";

import dom from "abusesa-js/ui/dom";

import deepEqual from "lib/deepEqual";

import "./Modal.css";

class Modal extends Component {
    static propTypes = {
        title: PropTypes.string,
        content: PropTypes.element.isRequired,
        onClose: PropTypes.func.isRequired
    };

    static defaultProps = {
        title: "",
        content: null,
        onClose: null
    };

    @autobind
    close(e) {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        return (
            <div className="modal">
                <div className="modal-title">{this.props.title}</div>
                <div className="modal-close-button" onClick={this.close}></div>
                <div className="modal-content">
                    {this.props.content}
                </div>
            </div>
        );
    }
}

export class ModalLauncher extends Component {
    static propTypes = {
        title: PropTypes.string,
        trigger: PropTypes.element,
        onShow: PropTypes.func,
        containerNode: PropTypes.node,
        children: PropTypes.node
    };

    static defaultProps = {
        title: "",
        trigger: null,
        onShow: null
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }

    getOverlayParentNode() {
        return this.props.containerNode || document.body;
    }

    @autobind
    close() {
        this.setState({open: false});
    }

    @autobind
    open() {
        this.setState({open: true});
    }

    updatePopup(prevState) {
        let el = this.modalContainer;
        if (this.state.open) {
            if (!prevState.open){
                this.getOverlayParentNode().appendChild(el);
            }

            ReactDOM.render(
                <Modal
                    content={this.props.children}
                    title={this.props.title}
                    onClose={this.close}
                />,
                el);

            if (!prevState.open && this.props.onShow) {
                this.props.onShow();
            }
        } else {
            el.remove();
        }
    }

    componentDidMount() {
        let el = this.modalContainer = dom.createElement("div", {
            "class": "modal-container"
        });

        this.closelisteners = [
            dom.listen(el, "click", (e)=> {
                if (e.target === el || e.target.parentNode === el) {
                    this.close();
                }
            }),
            dom.listen(document, "keydown", (e) => {
                if (!this.state.open) {
                    return;
                }

                //close when esc key is pressed
                if (e.keyCode === 27) {
                    const tagRex = /^(button|input|textarea|select)$/i;

                    if (e.target.tagName && e.target.tagName.match(tagRex)) {
                        e.target.blur();
                    }

                    this.close();
                }
            })
        ];
        this.updatePopup();
    }

    componentDidUpdate(props, state) {
        this.updatePopup(state);
    }

    componentWillUnmount() {
        let el = this.modalContainer;
        ReactDOM.unmountComponentAtNode(el);
        this.closelisteners.forEach(listener => listener.destroy());
        el.remove();
    }

    render() {
        return React.cloneElement(this.props.trigger, {onClick: this.open});
    }
}

export class TriggerMixin extends Component {
    static propTypes = {
        title: PropTypes.string,
        trigger: PropTypes.element,
        onShow: PropTypes.func,
        children: PropTypes.node
    };

    @autobind
    onShow() {
        this.forceUpdate();
    }

    @autobind
    open() {
        this.modal.open();
    }

    isOpen() {
        return this.modal.state.open;
    }

    @autobind
    close() {
        this.modal.close();
    }

    shouldComponentUpdate(nextProps) {
        return this.isOpen() && !deepEqual(nextProps, this.props);
    }

    render() {
        let onShow = this.props.onShow || this.onShow;
        return (
            <ModalLauncher
                ref={modal => this.modal = modal}
                title={this.props.title}
                trigger={this.renderTrigger()}
                onShow={onShow}
            >
                {this.renderContent()}
            </ModalLauncher>
        );
    }

    renderTrigger() {
        return this.props.children;
    }

    renderContent() {
        return null;
    }
}

export default TriggerMixin;

export function isOpen(){
    return document.body.querySelectorAll(".modal-container").length > 0;
}



// WEBPACK FOOTER //
// ./src/kpi/components/Modal.jsx